import React from 'react'
import { Link, useParams } from 'react-router-dom'

const Menu = ({ eateries }) => {

    let {id} = useParams(); //menu items 

  return ( 
    // To pass multiple props via useParams, you only pass one prop (ID) and also pass in the data. Hence using the ID you 
    // assort through the data for that specific ID.
    <div className="menu-group">
        <h1>Restaurant Details</h1>

        {eateries.filter(product => product.id === (id)).map((product) => ( //parseInt(id) to convert id string to number if need be.
            
            <div>
                <h3>{product.name}</h3>
                <p>Contact number: {product.display_phone}</p>
                <p>Address: {product.location.address1 }</p>
                <p>Availability: {product.is_closed ? 'Closed' : 'Open'}</p>
                <div className="menu-nav">
                <Link className="Button" to='/'>Go Back</Link>
                <br/>
                <br/>
                <br/> 
                <a className="Button" target="_blank" rel="noopener noreferrer" href={product.url}>Visit restaurant page on Yelp</a>
                </div>
            </div>
           
        ))}
    </div>
  )
}

export default Menu